/**
 * Enable to turn on phase 1 of brand multi user  * where we allow brands to add sub-users that have all the same capabilities
 */
export const ENABLE_BRAND_MULTI_USER_PHASE_1_240223 = 'ENABLE_BRAND_MULTI_USER_PHASE_1_240223';
